import { Injectable, inject } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable, shareReplay } from 'rxjs'

export interface RuntimeConfig {
  apiBaseUrl: string
  [key: string]: unknown
}

@Injectable({ providedIn: 'root' })
// Load a runtime config JSON once and expose it via cached Observable.
export class ConfigService {
  private http = inject(HttpClient)
  private config$?: Observable<RuntimeConfig>

  load(url: string = '/assets/config.json'): Observable<RuntimeConfig> {
    this.config$ = this.http.get<RuntimeConfig>(url).pipe(shareReplay({ bufferSize: 1, refCount: true }))
    return this.config$
  }

  get(): Observable<RuntimeConfig> {
    if (!this.config$) {
      this.config$ = this.load()
    }
    return this.config$
  }
}
